// Calendar-date fields (debt due dates, billing dates) come back from the API
// as UTC-midnight timestamps ("2026-08-01T00:00:00+00:00"). Parsing those with
// new Date() and formatting in a US timezone shows the previous day, so build
// a local-midnight Date from the date portion instead.
export function parseDateOnly(value) {
  if (!value) return null;
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return new Date(value);
  return new Date(+m[1], +m[2] - 1, +m[3]);
}

// Local calendar date as "YYYY-MM-DD" — for <input type=date> defaults and
// date math. new Date().toISOString().split('T')[0] flips to tomorrow after
// ~8pm Eastern because toISOString reports the UTC date.
export function toLocalISODate(d = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
